const entityAliases: Record<string, string> = {
	users: 'user',
	teams: 'team',
	roles: 'role',
	skills: 'skill',
	skillgroups: 'skillgroup',
	queues: 'queue',
	templates: 'template',
	custompages: 'custompage',
	customproperties: 'customproperty',
	rulesets: 'ruleset',
	pausereasons: 'pausereason',
	contactcodetree: 'contactcode',
	contactcodetrees: 'contactcode',
	contactcodetreeid: 'contactcode',
	contactcode: 'contactcode',
	permissions: 'permission',
	organizationunit: 'organizationalunit',
	organizationalunits: 'organizationalunit',
	entityfilters: 'entityfilter',
	rulesetid: 'ruleset',
	rulesetname: 'ruleset',
}

export function normalizeEntityKey(entity: string): string {
	const normalized = entity.replaceAll(/[-_\s]/g, '').toLowerCase()
	return entityAliases[normalized] ?? normalized
}
